<template>
	<v-snackbar
			v-model="componentState_.showInformationSnackbar"
			bottom
			:timeout="$_sb_stateComponentInformationSnackbarTimeout">
		<v-row dense align="center">
			<template v-if="!isFalse($_sb_stateComponentInformationSnackbarIcon)">
				<v-col cols="auto">
					<v-icon class="icon_" v-text="$_sb_stateComponentInformationSnackbarIcon" />
				</v-col>
			</template>	
			<v-col>
				<v-btn	class="customVBtn button_"
						block
						text
						@click="openLink($_sb_stateComponentInformationSnackbarLink)">
					<span v-text="$_sb_stateComponentInformationSnackbarText" />
				</v-btn>
			</v-col>
			<v-col cols="auto">
				<v-btn	class="customVBtn"
						icon
						text
						@click="$_sb_close()">
					<v-icon>close</v-icon>
				</v-btn>		
			</v-col>
		</v-row>
	</v-snackbar>
</template>

<script>
	export default {
		name: 'InformationSnackbar',
		data() {
			return {
				componentState_: null
			}
		},
		computed: {
			$_sb_stateComponentInformationSnackbar() {
				const self_ = this;
				return () => {
					return self_.getComponentState('informationSnackbar')
				}
			},
			$_sb_stateComponentInformationSnackbarIcon() {
				const self_ = this;
				const snackbar_ = self_.$_sb_stateComponentInformationSnackbar()
				return snackbar_.icon
			},
			$_sb_stateComponentInformationSnackbarLink() {
				const self_ = this;
				const snackbar_ = self_.$_sb_stateComponentInformationSnackbar()
				return snackbar_.link
			},
			$_sb_stateComponentInformationSnackbarText() {
				const self_ = this;
				const snackbar_ = self_.$_sb_stateComponentInformationSnackbar()
				return snackbar_.text
			},
			$_sb_stateComponentInformationSnackbarTimeout() {
				const self_ = this;
				const snackbar_ = self_.$_sb_stateComponentInformationSnackbar()
				return snackbar_.timeout
			}
		},
		created() {
			const self_ = this;

			self_.componentState_ = self_.getState('component')
		},
		methods: {
			$_sb_close() {
				const self_ = this;
				// hdie
				self_.hideSnackbar()
			}
		}
	}
</script>

<style scoped>
	.icon_ {
		margin: 0 12px;
	}
	.button_ {
		margin-left: 0 !important;
		text-transform: none;
	}
</style>